import type { GoodsInfo } from './good-info.model';

/**
 * eBASE取込（新規＋更新）画面Output用VOクラス
 *
 * @export KYMW1108OutputModel
 * @class KYMW1108OutputModel
 */
export class KYMW1108OutputModel {
  // eBASE 取込商品候補一覧
  selectedGoodsInfoList: GoodsInfo[] = [];
}
